import React, { SVGProps } from "react";

export default function OdIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="Assets"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g transform="translate(-85.000000, -310.000000)" id="ic_od">
          <g transform="translate(85.000000, 310.000000)">
            <rect
              id="bg"
              fill="#FFFFFF"
              fillRule="nonzero"
              x="1"
              y="1"
              width="38"
              height="38"
              rx="2"
            ></rect>
            <path
              d="M4,3 L11.5,3 L11.5,11.5 L3,11.5 L3,4 C3,3.44771525 3.44771525,3 4,3 Z"
              id="Path"
              fill="#1B2F5C"
              fillRule="nonzero"
            ></path>
            <rect
              id="Rectangle"
              fill="#084C7E"
              fillRule="nonzero"
              x="11.5"
              y="3"
              width="8.5"
              height="8.5"
            ></rect>
            <rect
              id="Rectangle"
              fill="#156DA3"
              fillRule="nonzero"
              x="20"
              y="3"
              width="8.5"
              height="8.5"
            ></rect>
            <path
              d="M28.5,3 L36,3 C36.5522847,3 37,3.44771525 37,4 L37,11.5 L28.5,11.5 L28.5,3 Z"
              id="Path"
              fill="#2B8BBB"
              fillRule="nonzero"
            ></path>
            <rect
              id="Rectangle"
              fill="#2B8BBB"
              fillRule="nonzero"
              x="3"
              y="11.5"
              width="8.5"
              height="8.5"
            ></rect>
            <rect
              id="Rectangle"
              fill="#156DA3"
              fillRule="nonzero"
              x="11.5"
              y="11.5"
              width="8.5"
              height="8.5"
            ></rect>
            <rect
              id="Rectangle"
              fill="#084C7E"
              fillRule="nonzero"
              x="20"
              y="11.5"
              width="8.5"
              height="8.5"
            ></rect>
            <rect
              id="Rectangle"
              fill="#1B2F5C"
              fillRule="nonzero"
              x="28.5"
              y="11.5"
              width="8.5"
              height="8.5"
            ></rect>
            <rect
              id="Rectangle"
              fill="#156DA3"
              fillRule="nonzero"
              x="3"
              y="20"
              width="8.5"
              height="8.5"
            ></rect>
            <rect
              id="Rectangle"
              fill="#1B2F5C"
              fillRule="nonzero"
              x="11.5"
              y="20"
              width="8.5"
              height="8.5"
            ></rect>
            <rect
              id="Rectangle"
              fill="#2B8BBB"
              fillRule="nonzero"
              x="20"
              y="20"
              width="8.5"
              height="8.5"
            ></rect>
            <rect
              id="Rectangle"
              fill="#FFFFFF"
              fillRule="nonzero"
              x="28.5"
              y="20"
              width="8.5"
              height="8.5"
            ></rect>
            <path
              d="M3,28.5 L11.5,28.5 L11.5,37 L4,37 C3.44771525,37 3,36.5522847 3,36 L3,28.5 Z"
              id="Path"
              fill="#084C7E"
              fillRule="nonzero"
            ></path>
            <polygon
              id="Path"
              fill="#1B2F5C"
              points="20 30.5 13.5 30.5 13.5 37 20 37 26.5 37 26.5 30.5"
            ></polygon>
            <path
              d="M28.5,28.5 L37,28.5 L37,36 C37,36.5522847 36.5522847,37 36,37 L28.5,37 L28.5,28.5 Z"
              id="Path"
              fill="#2B8BBB"
              fillRule="nonzero"
            ></path>
            <rect
              id="Rectangle"
              fill="#1B2F5C"
              fillRule="nonzero"
              x="30.22"
              y="21.75"
              width="6.78"
              height="5"
            ></rect>
            <path
              d="M17.52,6.81 L20,6.81 C20.810821,6.75646475 21.6031123,7.06824606 22.16,7.66 C22.7261429,8.41437193 22.9964924,9.34992359 22.92,10.29 C22.9321712,10.9362378 22.8166284,11.5785198 22.58,12.18 C22.3802338,12.6627893 22.0515938,13.0813729 21.63,13.39 C21.2113192,13.6731172 20.7153242,13.8198199 20.21,13.81 L17.52,13.81 L17.52,6.81 Z M19.87,12.39 C20.3096477,12.4235542 20.7268491,12.1913384 20.93,11.8 C21.1497661,11.3174181 21.2525515,10.7897866 21.23,10.26 C21.2513121,9.75498904 21.1446787,9.25278005 20.92,8.8 C20.7165275,8.41608109 20.3027947,8.19148328 19.87,8.23 L19.17,8.23 L19.17,12.39 L19.87,12.39 Z"
              id="Shape"
              fill="#FEFEFE"
              fillRule="nonzero"
            ></path>
            <polygon
              id="Path"
              fill="#FEFEFE"
              fillRule="nonzero"
              points="15.33 6 16.87 6 14.17 14.58 12.63 14.58"
            ></polygon>
            <path
              d="M7.57,13.21 C7.10152393,12.6997824 6.85979648,12.0215024 6.9,11.33 L6.9,9.33 C6.85979648,8.63849763 7.10152393,7.96021762 7.57,7.45 C8.11259001,6.95336653 8.8366068,6.70358073 9.57,6.76 C10.3037058,6.7011309 11.0286745,6.95124512 11.57,7.45 C12.0125914,7.96127392 12.2385728,8.62487013 12.2,9.3 L12.2,11.3 C12.235659,11.9908445 11.9945397,12.6674178 11.53,13.18 C10.98455,13.6709293 10.2616493,13.9167156 9.53,13.86 C8.81621018,13.9127119 8.11084306,13.6787891 7.57,13.21 L7.57,13.21 Z M10.31,12.13 C10.4735819,11.8558577 10.5502832,11.5385932 10.53,11.22 L10.53,9.39 C10.550675,9.07770264 10.4737973,8.76669748 10.31,8.5 C10.1223505,8.28666781 9.8423554,8.17840302 9.56,8.21 C9.27450907,8.17675279 8.99077287,8.28502055 8.8,8.5 C8.62312279,8.76132498 8.54188025,9.07569828 8.57,9.39 L8.57,11.22 C8.54280723,11.5373674 8.62387562,11.8545915 8.8,12.12 C8.98975025,12.3372491 9.27302004,12.4490662 9.56,12.42 C9.84168629,12.4465988 10.119483,12.339184 10.31,12.13 L10.31,12.13 Z"
              id="Shape"
              fill="#FEFEFE"
              fillRule="nonzero"
            ></path>
            <path
              d="M37,1 C38.1045695,1 39,1.8954305 39,3 L39,37 C39,38.1045695 38.1045695,39 37,39 L3,39 C1.8954305,39 1,38.1045695 1,37 L1,3 C1,1.8954305 1.8954305,1 3,1 L37,1 M37,0 L3,0 C1.34314575,0 0,1.34314575 0,3 L0,37 C0,38.6568542 1.34314575,40 3,40 L37,40 C38.6568542,40 40,38.6568542 40,37 L40,3 C40,1.34314575 38.6568542,0 37,0 Z"
              id="Border"
              fill="#E9E9E9"
              fillRule="nonzero"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
